import { render } from "./MainVouchers.vue?vue&type=template&id=e1bda6fa&scoped=true"
import script from "./MainVouchers.vue?vue&type=script&lang=js"
export * from "./MainVouchers.vue?vue&type=script&lang=js"

import "./MainVouchers.vue?vue&type=style&index=0&id=e1bda6fa&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1bda6fa"]])

export default __exports__